/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PatientPaymentTransactionType = typeof PatientPaymentTransactionType[keyof typeof PatientPaymentTransactionType];


export const PatientPaymentTransactionType = {
  Payment: 'Payment',
  Refund: 'Refund',
} as const;
